import { __assign } from "tslib";
// DS: i3.1
// from Vlada
import React from 'react';
import IconWrap from '../IconWrap';
var CloseSmall = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "0", height: "0", viewBox: "0 0 18 18" },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: "2" },
            React.createElement("path", { d: "M1 17L17 1 1 17zM17 17L1 1l16 16z" }))))); };
CloseSmall.displayName = 'CloseSmall';
export default CloseSmall;
//# sourceMappingURL=CloseSmall.js.map